<template>
    <!-- Generato da claude — Deskalo 2: split-panel login (navy sinistra, form destra) -->
    <div class="dk-login-wrap">

        <!-- Pannello sinistro: brand navy -->
        <div class="dk-login-left">
            <div class="dk-login-tagline">
                <strong>Il tuo desk, ovunque</strong>
                Gestisci prenotazioni, pagamenti<br>e abbonamenti direttamente<br>dal tuo telefono
            </div>
        </div>

        <!-- Pannello destro: form -->
        <div class="dk-login-right">
            <div class="dk-login-box">
                <div class="dk-login-logo-wrap">
                    <img src="@/assets/img/deskalo_logo_definitivo_trasparente.png" alt="Deskalo" class="dk-login-logo-img">
                </div>
                <div class="dk-login-subtitle">Accedi con email e PIN</div>

                <div class="mb-3">
                    <label class="form-label fw-bold">Email</label>
                    <input
                        type="email"
                        class="form-control form-control-lg"
                        placeholder="mario.rossi@email.it"
                        v-model="credenziali.EMAIL"
                        @keyup.enter="login()"
                        autocomplete="email"
                    >
                </div>

                <div class="mb-4">
                    <label class="form-label fw-bold">PIN</label>
                    <input
                        type="password"
                        class="form-control form-control-lg"
                        placeholder="PIN a 5 cifre"
                        maxlength="5"
                        v-model="credenziali.PIN"
                        @keyup.enter="login()"
                        autocomplete="current-password"
                        inputmode="numeric"
                    >
                </div>

                <div class="d-grid">
                    <button class="btn btn-dk-orange btn-lg" @click="login()">
                        <i class="fal fa-sign-in-alt fa-fw me-1"></i> Accedi
                    </button>
                </div>

                <!-- Generato da claude — Deskalo 2: link reset PIN dimenticato -->
                <div class="mt-3 text-center">
                    <button type="button" class="btn btn-link btn-sm text-muted" @click="apriPinDimenticato()">
                        PIN dimenticato?
                    </button>
                </div>

                <div class="mt-2 text-center">
                    <small class="text-muted">
                        Per ricevere il PIN contatta la segreteria<br>
                        <a href="mailto:info@isprint.it" class="text-muted">info@isprint.it</a>
                    </small>
                    <div class="mt-2">
                        <small class="text-muted" style="font-size:.7rem">v{{$root.VERSIONE}}</small>
                    </div>
                </div>
            </div>
        </div>

        <!-- Generato da claude — Deskalo 2: popup reset PIN dimenticato -->
        <div class="modal fade" id="popUpPinDimenticato" role="dialog" aria-modal="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header modal-header-info">
                        <h5 class="modal-title">PIN dimenticato</h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Chiudi"></button>
                    </div>
                    <div class="modal-body">
                        <p class="text-muted">Inserisci l'indirizzo email con cui accedi a Deskalo: se risulta associato a un profilo attivo, riceverai una email con il nuovo PIN.</p>
                        <div class="mb-3">
                            <label class="form-label">Email</label>
                            <input
                                type="email"
                                class="form-control"
                                placeholder="mario.rossi@email.it"
                                v-model="pinDimenticato.EMAIL"
                                @keyup.enter="inviaPinDimenticato()"
                                autocomplete="email"
                            >
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Annulla</button>
                        <button type="button" class="btn btn-dk-orange" @click="inviaPinDimenticato()">
                            <i class="fal fa-paper-plane fa-fw me-1"></i> Invia
                        </button>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
// Generato da claude — Deskalo 2: login email+PIN su G_T_SOCI
export default {
    name: 'Login',
    data: function() {
        return {
            credenziali: {
                EMAIL: '',
                PIN: ''
            },
            pinDimenticato: {
                EMAIL: ''
            }
        }
    },
    methods: {
        login() {
            if (!this.credenziali.EMAIL || !this.credenziali.PIN) {
                global.utils.alert.warning('Inserisci email e PIN');
                return;
            }
            global.utils.ajax('deskalo/login', { EMAIL: this.credenziali.EMAIL, PIN: this.credenziali.PIN }, (response) => {
                if (response.esito == 0) {
                    global.utils.setCookie('session_token', response.data.SESSION_TOKEN);
                    this.$root.startHandler();
                } else {
                    global.utils.alert.warning(response.messaggio || 'Credenziali non valide');
                }
            });
        },
        // Generato da claude — Deskalo 2: reset PIN self-service via email
        apriPinDimenticato() {
            this.pinDimenticato = { EMAIL: this.credenziali.EMAIL || '' };
            global.$('#popUpPinDimenticato').modal('show');
        },
        inviaPinDimenticato() {
            if (!this.pinDimenticato.EMAIL) {
                global.utils.alert.warning('Inserisci il tuo indirizzo email');
                return;
            }
            global.utils.ajax('deskalo/pin/dimenticato', { EMAIL: this.pinDimenticato.EMAIL }, (response) => {
                if (response.esito == 0) {
                    global.$('#popUpPinDimenticato').modal('hide');
                    global.utils.alert.success('Se l\'indirizzo inserito è associato a un profilo Deskalo, riceverai a breve una email con il nuovo PIN.');
                } else {
                    global.utils.alert.warning(response.messaggio);
                }
            });
        }
    },
    created: function() {
        // nessuna navbar su login — assicura che il body non abbia padding-top residuo
    }
}
</script>
